import classNames from "classnames";
import { inject, observer } from "mobx-react";
import React from "react";
import { Avatar } from "@fidget/common/components/avatar/avatar";
import { AudioPlaybackWithTrack } from "@fidget/common/components/call/audioPlayback";
import { VideoPlaybackWithTrack } from "@fidget/common/components/call/videoPlayback";
import { WidgetContext } from "../../context";
import { IForeCallStore } from "../../models/call/foreCallModel";

import styles from "./widgetVideoSection.css";

interface Props {
  context: WidgetContext;
  foreCallStore?: IForeCallStore;
  isMobile?: boolean;
}

@inject("foreCallStore")
@observer
export class WidgetVideoSection extends React.Component<Props, {}> {
  get injected(): { foreCallStore: IForeCallStore } {
    return this.props as { foreCallStore: IForeCallStore };
  }

  render() {
    const call = this.injected.foreCallStore;
    const assignedAgent = this.props.context.state.shared.assignedAgent;

    return (
      <div
        className={classNames(styles["video-container"], {
          [styles.isMobile]: this.props.isMobile
        })}
      >
        <div
          className={[
            styles["video-wrapper"],
            call.videoExpanded ? styles["video-expanded"] : ""
          ].join(" ")}
        >
          {(call.remoteVideo.isPlayable && call.remoteVideo.track && (
            <VideoPlaybackWithTrack track={call.remoteVideo.track} />
          )) || <Avatar user={assignedAgent} widgetStyle />}
          {this.renderAudio()}
        </div>
        <div className={styles["client-wrapper"]}>
          {call.localCamera.isPlayable && call.localCamera.track && (
            <div className={styles["video-wrapper"]}>
              <VideoPlaybackWithTrack track={call.localCamera.track} />
            </div>
          )}
          {!call.localMicrophone.enabled && (
            <i
              className={["icon-crossed-mic", styles["mic-muted"]]
                .concat([call.localCamera.enabled ? styles["with-camera"] : ""])
                .join(" ")}
            />
          )}
        </div>
      </div>
    );
  }

  private renderAudio() {
    const remoteAudio = this.injected.foreCallStore.remoteAudio;
    return (
      remoteAudio.isPlayable &&
      remoteAudio.track && <AudioPlaybackWithTrack track={remoteAudio.track} />
    );
  }
}
